import React, { useEffect } from "react";
// react plugin for creating charts
// @material-ui/core
import { Icon } from "@mui/material";
// @mui/icons-material
import Store from "@mui/icons-material/Store";
import Warning from "@mui/icons-material/Warning";
import DateRange from "@mui/icons-material/DateRange";
import Update from "@mui/icons-material/Update";
import Accessibility from "@mui/icons-material/Accessibility";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import Danger from "../../components/Typography/Danger.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardIcon from "../../components/Card/CardIcon.js";
import CardFooter from "../../components/Card/CardFooter.js";
import Layout from '../../core/Layout';

import styles from "../../assets/jss/material-dashboard-react/views/dashboardStyle.js";

import { useDispatch, useSelector } from "react-redux";
import { getDashboard } from "../../reduxStore/entities/dashboard";


export default function Dashboard() {
  const dashboard = useSelector((state) => state.dashboard.dashboard);

  const dispatch = useDispatch();

  useEffect(() => {
    const doasync = (async () => {
      dispatch(getDashboard());
    })
    doasync();
  }, [dispatch]);

  /*
    useEffect(()=>{
      console.log(offer)
      setRows(populateTable(offer))
    },[dashboard,dataLoaded]);
     { totalUsers: 6, totalUser24h: 6,
      totalPartrequests24h: 27, totalSuccessfulPartrequests24h: 27,
       totalPartrequestsEndedWithoutOffers24h: 27, totalPartrequestsWinnerNotSelected24h: 27,
        newPartsSold24h: 27, usedPartsSold24h: 27 }
    */

  return (

    <Layout>
      <div>
        <GridContainer>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <Store />
                </CardIcon>
                <p style={styles.cardCategory}>Zahtevi </p>
                <h3 style={styles.cardTitle}>{dashboard.newPartsSold24h} kom </h3>
              </CardHeader>
              <CardFooter stats>
                <div style={styles.stats}>
                  <DateRange />
                  Last 24 Hours
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <Store />
                </CardIcon>
                <p style={styles.cardCategory}>
                  Zahtevi 24h
                </p>

                <h3 style={styles.cardTitle}>{dashboard.usedPartsSold24h} kom</h3>

              </CardHeader>
              <CardFooter stats>
                <div style={styles.stats}>
                  <DateRange />
                  Last 24 Hours
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <Icon>people</Icon>
                </CardIcon>
                <p style={styles.cardCategory}> Ukupno korisnika</p>
                <h3 style={styles.cardTitle}>
                  {dashboard.totalUsers}
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div style={styles.stats}>
                  <Danger>
                    <Warning />
                  </Danger>
                  <a href="#tuki" onClick={e => e.preventDefault()}>
                    Detaljnije
                  </a>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <Accessibility />
                </CardIcon>
                <p style={styles.cardCategory}>Novih korisnika 24h</p>
                <h3 style={styles.cardTitle}>+{dashboard.totalUser24h}</h3>
              </CardHeader>
              <CardFooter stats>
                <div style={styles.stats}>
                  <Update />
                  Just Updated
                </div>
              </CardFooter>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <Icon>info_outline</Icon>
                </CardIcon>
                <p style={styles.cardCategory}>Automobili</p>
                <h3 style={styles.cardTitle}>{dashboard.totalPartrequests24h}</h3>
              </CardHeader>
              <CardFooter stats>
                <div style={styles.stats}>
                  <DateRange />
                  Last 24 Hours
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <Icon>info_outline</Icon>
                </CardIcon>
                <p style={styles.cardCategory}>Automobili 24h</p>
                <h3 style={styles.cardTitle}>{dashboard.totalSuccessfulPartrequests24h}</h3>
              </CardHeader>
              <CardFooter stats>
                <div style={styles.stats}>
                  <DateRange />
                  Last 24 Hours
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="danger" stats icon>
                <CardIcon color="danger">
                  <Icon>info_outline</Icon>
                </CardIcon>
                <p style={styles.cardCategory}>Ponude</p>
                <h3 style={styles.cardTitle}>{dashboard.totalPartrequestsEndedWithoutOffers24h}</h3>
              </CardHeader>
              <CardFooter stats>
                <div style={styles.stats}>
                  <DateRange />
                  Last 24 Hours
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="danger" stats icon>
                <CardIcon color="danger">
                  <Icon>info_outline</Icon>
                </CardIcon>
                <p style={styles.cardCategory}>Ponude 24h</p>
                <h3 style={styles.cardTitle}>{dashboard.totalPartrequestsWinnerNotSelected24h}</h3>
              </CardHeader>
              <CardFooter stats>
                <div style={styles.stats}>
                  <DateRange />
                  Last 24 Hours
                </div>
              </CardFooter>
            </Card>
          </GridItem>

        </GridContainer>
        {/*<GridContainer>*/}
        {/*  <GridItem xs={12} sm={12} md={4}>*/}
        {/*    <Card chart>*/}
        {/*      <CardHeader color="info">*/}
        {/*        <ChartistGraph*/}
        {/*            className="ct-chart"*/}
        {/*            data={dailySalesChart.data}*/}
        {/*            type="Line"*/}
        {/*            options={dailySalesChart.options}*/}
        {/*            listener={dailySalesChart.animation}*/}
        {/*        />*/}
        {/*      </CardHeader>*/}
        {/*      <CardBody>*/}
        {/*        <h4 className={styles.cardTitle}>Broj korisnika 7 dana</h4>*/}
        {/*        <p className={styles.cardCategory}>*/}
        {/*          <span className={styles.successText}>*/}
        {/*            <ArrowUpward className={styles.upArrowCardCategory} /> 25%*/}
        {/*          </span>{" "}*/}
        {/*          vise nego prethodne nedelje.*/}
        {/*        </p>*/}
        {/*      </CardBody>*/}
        {/*      <CardFooter chart>*/}
        {/*        <div className={styles.stats}>*/}
        {/*          <AccessTime /> updated 4 minutes ago*/}
        {/*        </div>*/}
        {/*      </CardFooter>*/}
        {/*    </Card>*/}
        {/*  </GridItem>*/}
        {/*  <GridItem xs={12} sm={12} md={4}>*/}
        {/*    <Card chart>*/}
        {/*      <CardHeader color="success">*/}
        {/*        <ChartistGraph*/}
        {/*            className="ct-chart"*/}
        {/*            data={dailySalesChart.data}*/}
        {/*            type="Line"*/}
        {/*            options={dailySalesChart.options}*/}
        {/*            listener={dailySalesChart.animation}*/}
        {/*        />*/}
        {/*      </CardHeader>*/}
        {/*      <CardBody>*/}
        {/*        <h4 className={styles.cardTitle}>Prodato novih 7 dana</h4>*/}
        {/*        <p className={styles.cardCategory}>*/}
        {/*          <span className={styles.successText}>*/}
        {/*            <ArrowUpward className={styles.upArrowCardCategory} /> 15%*/}
        {/*          </span>{" "}*/}
        {/*          vise.*/}
        {/*        </p>*/}
        {/*      </CardBody>*/}
        {/*      <CardFooter chart>*/}
        {/*        <div className={styles.stats}>*/}
        {/*          <AccessTime /> updated 4 minutes ago*/}
        {/*        </div>*/}
        {/*      </CardFooter>*/}
        {/*    </Card>*/}
        {/*  </GridItem>*/}
        {/*  <GridItem xs={12} sm={12} md={4}>*/}
        {/*    <Card chart>*/}
        {/*      <CardHeader color="success">*/}
        {/*        <ChartistGraph*/}
        {/*            className="ct-chart"*/}
        {/*            data={dailySalesChart.data}*/}
        {/*            type="Line"*/}
        {/*            options={dailySalesChart.options}*/}
        {/*            listener={dailySalesChart.animation}*/}
        {/*        />*/}
        {/*      </CardHeader>*/}
        {/*      <CardBody>*/}
        {/*        <h4 className={styles.cardTitle}>Prodato polovnih 7 dana</h4>*/}
        {/*        <p className={styles.cardCategory}>*/}
        {/*          <span className={styles.successText}>*/}
        {/*            <ArrowUpward className={styles.upArrowCardCategory} /> 85%*/}
        {/*          </span>{" "}*/}
        {/*          vise.*/}
        {/*        </p>*/}
        {/*      </CardBody>*/}
        {/*      <CardFooter chart>*/}
        {/*        <div className={styles.stats}>*/}
        {/*          <AccessTime /> updated 4 minutes ago*/}
        {/*        </div>*/}
        {/*      </CardFooter>*/}
        {/*    </Card>*/}
        {/*  </GridItem>*/}
        {/*  <GridItem xs={12} sm={12} md={4}>*/}
        {/*    <Card chart>*/}
        {/*      <CardHeader color="success">*/}
        {/*        <ChartistGraph*/}
        {/*            className="ct-chart"*/}
        {/*            data={dailySalesChart.data}*/}
        {/*            type="Line"*/}
        {/*            options={dailySalesChart.options}*/}
        {/*            listener={dailySalesChart.animation}*/}
        {/*        />*/}
        {/*      </CardHeader>*/}
        {/*      <CardBody>*/}
        {/*        <h4 className={styles.cardTitle}>Daily Sales</h4>*/}
        {/*        <p className={styles.cardCategory}>*/}
        {/*          <span className={styles.successText}>*/}
        {/*            <ArrowUpward className={styles.upArrowCardCategory} /> 55%*/}
        {/*          </span>{" "}*/}
        {/*          increase in today sales.*/}
        {/*        </p>*/}
        {/*      </CardBody>*/}
        {/*      <CardFooter chart>*/}
        {/*        <div className={styles.stats}>*/}
        {/*          <AccessTime /> updated 4 minutes ago*/}
        {/*        </div>*/}
        {/*      </CardFooter>*/}
        {/*    </Card>*/}
        {/*  </GridItem>*/}
        {/*  <GridItem xs={12} sm={12} md={4}>*/}
        {/*    <Card chart>*/}
        {/*      <CardHeader color="success">*/}
        {/*        <ChartistGraph*/}
        {/*            className="ct-chart"*/}
        {/*            data={dailySalesChart.data}*/}
        {/*            type="Line"*/}
        {/*            options={dailySalesChart.options}*/}
        {/*            listener={dailySalesChart.animation}*/}
        {/*        />*/}
        {/*      </CardHeader>*/}
        {/*      <CardBody>*/}
        {/*        <h4 className={styles.cardTitle}>Daily Sales</h4>*/}
        {/*        <p className={styles.cardCategory}>*/}
        {/*          <span className={styles.successText}>*/}
        {/*            <ArrowUpward className={styles.upArrowCardCategory} /> 55%*/}
        {/*          </span>{" "}*/}
        {/*          increase in today sales.*/}
        {/*        </p>*/}
        {/*      </CardBody>*/}
        {/*      <CardFooter chart>*/}
        {/*        <div className={styles.stats}>*/}
        {/*          <AccessTime /> updated 4 minutes ago*/}
        {/*        </div>*/}
        {/*      </CardFooter>*/}
        {/*    </Card>*/}
        {/*  </GridItem>*/}
        {/*  <GridItem xs={12} sm={12} md={4}>*/}
        {/*    <Card chart>*/}
        {/*      <CardHeader color="warning">*/}
        {/*        <ChartistGraph*/}
        {/*            className="ct-chart"*/}
        {/*            data={emailsSubscriptionChart.data}*/}
        {/*            type="Bar"*/}
        {/*            options={emailsSubscriptionChart.options}*/}
        {/*            responsiveOptions={emailsSubscriptionChart.responsiveOptions}*/}
        {/*            listener={emailsSubscriptionChart.animation}*/}
        {/*        />*/}
        {/*      </CardHeader>*/}
        {/*      <CardBody>*/}
        {/*        <h4 className={styles.cardTitle}>Email Subscriptions</h4>*/}
        {/*        <p className={styles.cardCategory}>Last Campaign Performance</p>*/}
        {/*      </CardBody>*/}
        {/*      <CardFooter chart>*/}
        {/*        <div className={styles.stats}>*/}
        {/*          <AccessTime /> campaign sent 2 days ago*/}
        {/*        </div>*/}
        {/*      </CardFooter>*/}
        {/*    </Card>*/}
        {/*  </GridItem>*/}
        {/*  <GridItem xs={12} sm={12} md={4}>*/}
        {/*    <Card chart>*/}
        {/*      <CardHeader color="danger">*/}
        {/*        <ChartistGraph*/}
        {/*            className="ct-chart"*/}
        {/*            data={completedTasksChart.data}*/}
        {/*            type="Line"*/}
        {/*            options={completedTasksChart.options}*/}
        {/*            listener={completedTasksChart.animation}*/}
        {/*        />*/}
        {/*      </CardHeader>*/}
        {/*      <CardBody>*/}
        {/*        <h4 className={styles.cardTitle}>Completed Tasks</h4>*/}
        {/*        <p className={styles.cardCategory}>Last Campaign Performance</p>*/}
        {/*      </CardBody>*/}
        {/*      <CardFooter chart>*/}
        {/*        <div className={styles.stats}>*/}
        {/*          <AccessTime /> campaign sent 2 days ago*/}
        {/*        </div>*/}
        {/*      </CardFooter>*/}
        {/*    </Card>*/}
        {/*  </GridItem>*/}
        {/*</GridContainer>*/}
        {/*<GridContainer>*/}
        {/*  <GridItem xs={12} sm={6} md={3}>*/}
        {/*    <Card>*/}
        {/*      <CardHeader color="warning" stats icon>*/}
        {/*        <CardIcon color="warning">*/}
        {/*          <Icon>content_copy</Icon>*/}
        {/*        </CardIcon>*/}
        {/*        <p className={styles.cardCategory}>Used Space</p>*/}
        {/*        <h3 className={styles.cardTitle}>*/}
        {/*          49/50 <small>GB</small>*/}
        {/*        </h3>*/}
        {/*      </CardHeader>*/}
        {/*      <CardFooter stats>*/}
        {/*        <div className={styles.stats}>*/}
        {/*          <Danger>*/}
        {/*            <Warning />*/}
        {/*          </Danger>*/}
        {/*          <a href="#pablo" onClick={e => e.preventDefault()}>*/}
        {/*            Get more space*/}
        {/*          </a>*/}
        {/*        </div>*/}
        {/*      </CardFooter>*/}
        {/*    </Card>*/}
        {/*  </GridItem>*/}
        {/*  <GridItem xs={12} sm={6} md={3}>*/}
        {/*    <Card>*/}
        {/*      <CardHeader color="success" stats icon>*/}
        {/*        <CardIcon color="success">*/}
        {/*          <Store />*/}
        {/*        </CardIcon>*/}
        {/*        <p className={styles.cardCategory}>Revenue</p>*/}
        {/*        <h3 className={styles.cardTitle}>$34,245</h3>*/}
        {/*      </CardHeader>*/}
        {/*      <CardFooter stats>*/}
        {/*        <div className={styles.stats}>*/}
        {/*          <DateRange />*/}
        {/*          Last 24 Hours*/}
        {/*        </div>*/}
        {/*      </CardFooter>*/}
        {/*    </Card>*/}
        {/*  </GridItem>*/}
        {/*  <GridItem xs={12} sm={6} md={3}>*/}
        {/*    <Card>*/}
        {/*      <CardHeader color="danger" stats icon>*/}
        {/*        <CardIcon color="danger">*/}
        {/*          <Icon>info_outline</Icon>*/}
        {/*        </CardIcon>*/}
        {/*        <p className={styles.cardCategory}>Fixed Issues</p>*/}
        {/*        <h3 className={styles.cardTitle}>75</h3>*/}
        {/*      </CardHeader>*/}
        {/*      <CardFooter stats>*/}
        {/*        <div className={styles.stats}>*/}
        {/*          <LocalOffer />*/}
        {/*          Tracked from Github*/}
        {/*        </div>*/}
        {/*      </CardFooter>*/}
        {/*    </Card>*/}
        {/*  </GridItem>*/}
        {/*  <GridItem xs={12} sm={6} md={3}>*/}
        {/*    <Card>*/}
        {/*      <CardHeader color="info" stats icon>*/}
        {/*        <CardIcon color="info">*/}
        {/*          <Accessibility />*/}
        {/*        </CardIcon>*/}
        {/*        <p className={styles.cardCategory}>Followers</p>*/}
        {/*        <h3 className={styles.cardTitle}>+245</h3>*/}
        {/*      </CardHeader>*/}
        {/*      <CardFooter stats>*/}
        {/*        <div className={styles.stats}>*/}
        {/*          <Update />*/}
        {/*          Just Updated*/}
        {/*        </div>*/}
        {/*      </CardFooter>*/}
        {/*    </Card>*/}
        {/*  </GridItem>*/}
        {/*</GridContainer>*/}
        {/*<GridContainer>*/}
        {/*  <GridItem xs={12} sm={12} md={4}>*/}
        {/*    <Card chart>*/}
        {/*      <CardHeader color="success">*/}
        {/*        <ChartistGraph*/}
        {/*          className="ct-chart"*/}
        {/*          data={dailySalesChart.data}*/}
        {/*          type="Line"*/}
        {/*          options={dailySalesChart.options}*/}
        {/*          listener={dailySalesChart.animation}*/}
        {/*        />*/}
        {/*      </CardHeader>*/}
        {/*      <CardBody>*/}
        {/*        <h4 className={styles.cardTitle}>Daily Sales</h4>*/}
        {/*        <p className={styles.cardCategory}>*/}
        {/*          <span className={styles.successText}>*/}
        {/*            <ArrowUpward className={styles.upArrowCardCategory} /> 55%*/}
        {/*          </span>{" "}*/}
        {/*          increase in today sales.*/}
        {/*        </p>*/}
        {/*      </CardBody>*/}
        {/*      <CardFooter chart>*/}
        {/*        <div className={styles.stats}>*/}
        {/*          <AccessTime /> updated 4 minutes ago*/}
        {/*        </div>*/}
        {/*      </CardFooter>*/}
        {/*    </Card>*/}
        {/*  </GridItem>*/}
        {/*  <GridItem xs={12} sm={12} md={4}>*/}
        {/*    <Card chart>*/}
        {/*      <CardHeader color="warning">*/}
        {/*        <ChartistGraph*/}
        {/*          className="ct-chart"*/}
        {/*          data={emailsSubscriptionChart.data}*/}
        {/*          type="Bar"*/}
        {/*          options={emailsSubscriptionChart.options}*/}
        {/*          responsiveOptions={emailsSubscriptionChart.responsiveOptions}*/}
        {/*          listener={emailsSubscriptionChart.animation}*/}
        {/*        />*/}
        {/*      </CardHeader>*/}
        {/*      <CardBody>*/}
        {/*        <h4 className={styles.cardTitle}>Email Subscriptions</h4>*/}
        {/*        <p className={styles.cardCategory}>Last Campaign Performance</p>*/}
        {/*      </CardBody>*/}
        {/*      <CardFooter chart>*/}
        {/*        <div className={styles.stats}>*/}
        {/*          <AccessTime /> campaign sent 2 days ago*/}
        {/*        </div>*/}
        {/*      </CardFooter>*/}
        {/*    </Card>*/}
        {/*  </GridItem>*/}
        {/*  <GridItem xs={12} sm={12} md={4}>*/}
        {/*    <Card chart>*/}
        {/*      <CardHeader color="danger">*/}
        {/*        <ChartistGraph*/}
        {/*          className="ct-chart"*/}
        {/*          data={completedTasksChart.data}*/}
        {/*          type="Line"*/}
        {/*          options={completedTasksChart.options}*/}
        {/*          listener={completedTasksChart.animation}*/}
        {/*        />*/}
        {/*      </CardHeader>*/}
        {/*      <CardBody>*/}
        {/*        <h4 className={styles.cardTitle}>Completed Tasks</h4>*/}
        {/*        <p className={styles.cardCategory}>Last Campaign Performance</p>*/}
        {/*      </CardBody>*/}
        {/*      <CardFooter chart>*/}
        {/*        <div className={styles.stats}>*/}
        {/*          <AccessTime /> campaign sent 2 days ago*/}
        {/*        </div>*/}
        {/*      </CardFooter>*/}
        {/*    </Card>*/}
        {/*  </GridItem>*/}
        {/*</GridContainer>*/}
        {/*<GridContainer>*/}
        {/*  <GridItem xs={12} sm={12} md={6}>*/}
        {/*    <CustomTabs*/}
        {/*      title="Tasks:"*/}
        {/*      headerColor="primary"*/}
        {/*      tabs={[*/}
        {/*        {*/}
        {/*          tabName: "Bugs",*/}
        {/*          tabIcon: BugReport,*/}
        {/*          tabContent: (*/}
        {/*            <Tasks*/}
        {/*              checkedIndexes={[0, 3]}*/}
        {/*              tasksIndexes={[0, 1, 2, 3]}*/}
        {/*              tasks={bugs}*/}
        {/*            />*/}
        {/*          )*/}
        {/*        },*/}
        {/*        {*/}
        {/*          tabName: "Website",*/}
        {/*          tabIcon: Code,*/}
        {/*          tabContent: (*/}
        {/*            <Tasks*/}
        {/*              checkedIndexes={[0]}*/}
        {/*              tasksIndexes={[0, 1]}*/}
        {/*              tasks={website}*/}
        {/*            />*/}
        {/*          )*/}
        {/*        },*/}
        {/*        {*/}
        {/*          tabName: "Server",*/}
        {/*          tabIcon: Cloud,*/}
        {/*          tabContent: (*/}
        {/*            <Tasks*/}
        {/*              checkedIndexes={[1]}*/}
        {/*              tasksIndexes={[0, 1, 2]}*/}
        {/*              tasks={server}*/}
        {/*            />*/}
        {/*          )*/}
        {/*        }*/}
        {/*      ]}*/}
        {/*    />*/}
        {/*  </GridItem>*/}
        {/*  <GridItem xs={12} sm={12} md={6}>*/}
        {/*    <Card>*/}
        {/*      <CardHeader color="warning">*/}
        {/*        <h4 className={styles.cardTitleWhite}>Employees Stats</h4>*/}
        {/*        <p className={styles.cardCategoryWhite}>*/}
        {/*          New employees on 15th September, 2016*/}
        {/*        </p>*/}
        {/*      </CardHeader>*/}
        {/*      <CardBody>*/}
        {/*        <Table*/}
        {/*          tableHeaderColor="warning"*/}
        {/*          tableHead={["ID", "Name", "Salary", "Country"]}*/}
        {/*          tableData={[*/}
        {/*            ["1", "Dakota Rice", "$36,738", "Niger"],*/}
        {/*            ["2", "Minerva Hooper", "$23,789", "Curaçao"],*/}
        {/*            ["3", "Sage Rodriguez", "$56,142", "Netherlands"],*/}
        {/*            ["4", "Philip Chaney", "$38,735", "Korea, South"]*/}
        {/*          ]}*/}
        {/*        />*/}
        {/*      </CardBody>*/}
        {/*    </Card>*/}
        {/*  </GridItem>*/}
        {/*</GridContainer>*/}
      </div></Layout>
  );
}
